import React, { useEffect, useRef, useState } from "react";
import { RiSearchLine } from "react-icons/ri";
import { FaAngleLeft } from "react-icons/fa";
import flag_2 from "./../../assets/img/tarh-parcham-iran-psdtarh2.png";
import MainLayout from "../../layout/main";
import { ApiEndpoints, useApiCall } from "../../api";
import Loading from "../../component/loading";
import { jalaliMonth, toDateString } from "../../helper/dateHelper";
import { useTableDataGenerator } from "../../helper/common";
import { appRoutes, useAppNavigation } from "../../router/routes";
import { RoleViewSelector } from "../../component/roleViewSelector";
import { UserRoles } from "../../storage/enums";
import { Table } from "../../component/table";
import { IoClose } from "react-icons/io5";
import { useAlert } from "react-alert";
import { storageApi } from "../../storage/storageApi";
import { MdOutlineFileDownload } from "react-icons/md";

const EventListPage = () => {
  const { navigate, queryParameter } = useAppNavigation();
  const [isMedia, setIsMedia] = useState(queryParameter().get("isMedia"));
  const [search, setSearch] = useState("");
  const [selectedMonth, setSelectedMonth] = useState("");

  const [[eventList], { loading }] = useApiCall({
    endpoints: ApiEndpoints.events.list,
    payload: {
      search,
      selectedMonth,
    },
  });

  useEffect(() => {
    if (isMedia) {
      openMediaDescription();
    }
  }, []);
  const userProfile = storageApi.useGetUser();
  const isAdmin = () => {
    return userProfile.role == "state_manager";
  };
  const [, { loading: checkPermissionLoading, fetch: checkPermission }] =
    useApiCall({
      endpoints: ApiEndpoints.events.permissions,
      payload: {
        search,
        selectedMonth,
      },
      lazy: true,
    });

  const { data } = useTableDataGenerator(eventList?.data ?? [], {
    filters: {
      title: search,
      month: selectedMonth,
    },
    pageSize: 1000,
  });

  const checkPermissionId = useRef(null);
  const alert = useAlert();
  const goAddProgram = async (item) => {
    if (!isAdmin()) {
      checkPermissionId.current = item.id;
      const [{ isOk, data }] = await checkPermission({ eventId: item.id });
      if (isOk) {
        if (!data.isAuthorize) {
          alert.error(data.message);
        } else {
          navigate(appRoutes.programAdd(item.id));
        }
      }
    } else {
      navigate(appRoutes.programList({ eventId: item.id }));
    }
  };
  const goToAddMedia = async (item) => {
    if (!isAdmin()) {
      navigate(appRoutes.mediaAdd(item.id));
    } else {
      navigate(appRoutes.programList({ eventId: item.id }));
    }
  };

  const goProgramList = (item) => {
    navigate(appRoutes.programList({ eventId: item.id }));
  };

  const [mediaDescription, setMediaDescription] = useState(null);
  const [description, setDescription] = useState(null);

  const openMediaDescription = () => {
    setMediaDescription(true);
  };

  const openDescription = (item) => {
    setDescription(item.description);
  };

  return (
    <MainLayout>
      <div className="content-style flex flex-col gap-8 md:p-8 p-4 bg-gray-100 shadow-sm w-full">
        {/* sec1 */}
        <div className="sec1 w-full bg-greenblue-light h-auto rounded-3xl relative md:p-8 p-4">
          <img src={flag_2} className=" absolute left-0 top-0 md:h-42 h-24" />
          <div className="flex flex-col gap-8 justify-center items-center md:w-[60%] w-full md:mt-0 mt-4 mx-auto">
            <div>
              <div className="md:text-3xl text-xl text-center font-bold">
                <span>انتخاب </span>
                <span className=" text-greenblue">مناسبت</span>
              </div>
              {!isAdmin() && (
                <p className="text-center">
                  برای ثبت برنامه، بر روی مناسبت مورد نظر کلیک کنید
                </p>
              )}
            </div>

            <div className=" w-full space-y-3">
              <div className="relative form-field">
                <input
                  type="text"
                  placeholder="مناسبت خود را جستجو کنید..."
                  className=" w-full p-4  border-2 border-gray-100 rounded-lg pr-10 pl-12"
                  onChange={(e) => setSearch(e.target.value)}
                />
                <div className=" absolute top-[50%] -translate-y-[50%] text-gray-400 right-2">
                  <RiSearchLine size={24} />
                </div>
              </div>
              <div className="flex justify-center">
                <select
                  onChange={(e) => setSelectedMonth(e.target.value)}
                  className=" w-[200px] p-3 rounded-lg"
                >
                  <option name="month" value="">
                    همه ماه ها
                  </option>
                  {jalaliMonth.map((c) => (
                    <option name={"month"} value={c}>
                      {c}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>
        </div>
        <Table
          loading={loading}
          data={data}
          header={[
            {
              name: "ردیف",
              width: 1,
              render: (i) => i.rowIndex,
            },
            {
              name: "عنوان مناسبت",
              width: 2,
              render: (i) => (
                <div
                  className={"text-blue-500 underline cursor-pointer"}
                  onClick={
                    userProfile.role === "customer"
                      ? () => goAddProgram(i)
                      : () => goProgramList(i)
                  }
                >
                  {i.title}
                </div>
              ),
            },
            {
              name: "محور فعالیت",
              width: 4,
              render: (i) => i.mehvar_faaliat,
            },
            {
              name: "ماه",
              width: 1,
              render: (i) => (
                <span className="p-2 px-4 border-2 border-gray-100 rounded-xl">
                  {i.month}
                </span>
              ),
            },
            {
              name: "تاریخ مناسبت",
              width: 2,
              render: (i) => toDateString(i.date, "jYYYY/jMM/jDD"),
            },
            {
              name: "عملیات",
              width: 2,
              render: (i) => (
                <RoleViewSelector>
                  <div
                    className={"w-full justify-around flex items-center"}
                    userRole={UserRoles.User}
                  >
                    {isMedia ? (
                      <div
                        onClick={() => goToAddMedia(i)}
                        className="max-w-[90%] cursor-pointer float-left gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl flex justify-center items-center"
                      >
                        انتخاب
                        <Loading
                          isLoading={
                            checkPermissionLoading &&
                            checkPermissionId.current === i.id
                          }
                          color={"blue"}
                        />
                        {(!checkPermissionLoading ||
                          checkPermissionId.current !== i.id) && (
                          <FaAngleLeft />
                        )}
                      </div>
                    ) : (
                      <div
                        onClick={() => goAddProgram(i)}
                        className="max-w-[90%] cursor-pointer float-left gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl flex justify-center items-center"
                      >
                        ثبت برنامه
                        <Loading
                          isLoading={
                            checkPermissionLoading &&
                            checkPermissionId.current === i.id
                          }
                          color={"blue"}
                        />
                        {(!checkPermissionLoading ||
                          checkPermissionId.current !== i.id) && (
                          <FaAngleLeft />
                        )}
                      </div>
                    )}
                    <div
                      onClick={() => openDescription(i)}
                      className="max-w-[90%] cursor-pointer gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl flex justify-center items-center"
                    >
                      توضیحات
                      <FaAngleLeft />
                    </div>
                  </div>
                  <div userRole={UserRoles.Admin} className="flex gap-1">
                    <div
                      onClick={() => goProgramList(i)}
                      className="flex items-center justify-center gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl cursor-pointer text-nowrap"
                    >
                      مشاهده برنامه ها
                      <FaAngleLeft />
                    </div>
                    <div
                      onClick={() => openDescription(i)}
                      className="max-w-[90%] cursor-pointer gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl flex justify-center items-center"
                    >
                      توضیحات
                      <FaAngleLeft />
                    </div>
                  </div>
                  <div userRole={UserRoles.ModireKol} className="flex gap-1">
                    <div
                      onClick={() => goProgramList(i)}
                      className="flex items-center justify-center gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl cursor-pointer text-nowrap"
                    >
                      مشاهده برنامه ها
                      <FaAngleLeft />
                    </div>
                    <div
                      onClick={() => openDescription(i)}
                      className="max-w-[90%] cursor-pointer gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl flex justify-center items-center"
                    >
                      توضیحات
                      <FaAngleLeft />
                    </div>
                  </div>
                  <div userRole={UserRoles.SazmanOstan} className="flex gap-1">
                    <div
                      onClick={() => goProgramList(i)}
                      className="flex items-center justify-center gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl cursor-pointer text-nowrap"
                    >
                      مشاهده برنامه ها
                      <FaAngleLeft />
                    </div>
                    <div
                      onClick={() => openDescription(i)}
                      className="max-w-[90%] cursor-pointer gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl flex justify-center items-center"
                    >
                      توضیحات
                      <FaAngleLeft />
                    </div>
                  </div>
                  <div userRole={UserRoles.Sazman} className="flex gap-1">
                    <div
                      onClick={() => goProgramList(i)}
                      className="flex items-center justify-center gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl cursor-pointer text-nowrap"
                    >
                      مشاهده برنامه ها
                      <FaAngleLeft />
                    </div>
                    <div
                      onClick={() => openDescription(i)}
                      className="max-w-[90%] cursor-pointer gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl flex justify-center items-center"
                    >
                      توضیحات
                      <FaAngleLeft />
                    </div>
                  </div>
                </RoleViewSelector>
              ),
            },
          ]}
        />
      </div>
      {description && (
        <div
          className={` bg-gray-900 bg-opacity-40 w-screen h-screen fixed top-0 left-0 `}
        >
          <div
            className="md:w-[700px] w-[350px] md:h-[600px] rounded-xl p-8 bg-white absolute top-[50%]
           -translate-y-[50%] left-[50%] -translate-x-[50%] max-h-[600px] overflow-auto"
          >
            <div className=" text-center text-lg font-semibold mb-4 mt-4">
              <div
                className=" absolute left-6 top-6 z-40 p-2 text-gray-500 cursor-pointer"
                onClick={() => setDescription(null)}
              >
                <IoClose size={24} />
              </div>
            </div>
            <div>توضیحات:</div>
            <p>{description}</p>
          </div>
        </div>
      )}
      {mediaDescription && (
        <div
          className={` bg-gray-900 bg-opacity-40 w-screen h-screen fixed top-0 left-0 `}
        >
          <div
            className="md:w-[700px] w-[350px] md:h-[600px] rounded-xl p-8 bg-white absolute top-[50%]
           -translate-y-[50%] left-[50%] -translate-x-[50%] max-h-[600px] overflow-auto"
          >
            <div className=" text-center text-lg font-semibold mb-4 mt-4">
              <div
                className=" absolute left-6 top-6 z-40 p-2 text-gray-500 cursor-pointer"
                onClick={() => setMediaDescription(null)}
              >
                <IoClose size={24} />
              </div>
            </div>
            <h3 className="text-xl text-center font-bold">توضیحات لازم</h3>
            <p className="font-bold my-5">
              این قسمت به منظور بارگذاری تولیدات فرهنگی و هنری کاربران با هدف
              استفاده و بهره برداری از سوی دیگر کاربران سازمان ها و نهادهای
              لشکری و کشوری ، ایجاد شده است. لذا رعایت شرایط زیر الزامی است :
            </p>
            <p>
              1- آثار تولیدی می بایست توسط کاربر( سازمان تابعه) تهیه و تولید شده
              باشد. از بارگذاری محصول و اثر دیگران و بارگیری شده از سایت ها و
              درگاه های اینترنتی خودداری فرمایید.
              <br />
              <br /> 2- از بارگذاری تصاویر و ویدئوهای گزارشی خودداری گردد.
              <br />
              <br /> 3- کیفیت آثار تولیدی گرافیکی می بایست قابل چاپ به صورت بنر
              یا پوستر نمایشگاهی و آثار صوتی و تصویری قابل پخش در دستگاه های
              صوتی و تصویری باشد.
              <br />
              <br /> 4- آثار بارگذاری شده بعد از تایید ناظرین استانی قابل مشاهده
              و بارگیری از سوی دیگر کاربران سازمانی خواهد بود. لذا از بارگذاری
              آثار بی کیفیت خودداری گردد.
              <br />
              <br /> 5- کیفیت هر تصویر گرافیکی بین 1 تا 3 مگابایت و هر اثر صوتی
              و تصویری بیشتر از 100 مگابایت نشود.
            </p>
            <button
              onClick={() => setMediaDescription(false)}
              className="flex items-center gap-1 bg-blue-100 text-blue-500 px-3 py-2 rounded-xl mt-3 mx-auto"
            >
              ادامه می دهم
            </button>
          </div>
        </div>
      )}
    </MainLayout>
  );
};

export default EventListPage;
